import React from 'react';
import PropTypes from 'prop-types';

import DependencyConsumer from './DependencyConsumer';
import ListenState from './ListenState';

const ChatCounter = ({ type, customStyle }) => (
  <DependencyConsumer name="TwilioController">
    {twilio => (
      <ListenState state={twilio.getState()}>
        {({ counters }) => (
          counters[type] > 0
            ? <span style={customStyle}>{counters[type]}</span>
            : null
        )}
      </ListenState>
    )}
  </DependencyConsumer>
);

ChatCounter.propTypes = {
  customStyle: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
};

export default ChatCounter;



// WEBPACK FOOTER //
// ./src/components/ChatCounter.js